export const genCssClass = (length = 3) => {
    // taken as is from figma-to-dom part
    const characters = 'abcdefghijklmnopqrstuvwxyz0123456789'
    const randomChar = () => characters[Math.floor(Math.random() * characters.length)]
    const randomCssClass = Array.from({ length }, randomChar).join('')
    return 'f' + randomCssClass
}

export const getJsonCircularReplacer = () => {
    const seen = new WeakSet()
    return (key, value) => {
        if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) {
                return // Handle circular reference
            }
            seen.add(value)
        }
        return value
    }
}

export const slugify = (s) => {
    // Asker ChatGPT to write function in JS with exact behavior of similar function used on backend

    const cyrillicLatinMap = {
        а: 'a',
        б: 'b',
        в: 'v',
        г: 'g',
        д: 'd',
        е: 'e',
        ё: 'yo',
        ж: 'zh',
        з: 'z',
        и: 'i',
        й: 'j',
        к: 'k',
        л: 'l',
        м: 'm',
        н: 'n',
        о: 'o',
        п: 'p',
        р: 'r',
        с: 's',
        т: 't',
        у: 'u',
        ф: 'f',
        х: 'kh',
        ц: 'ts',
        ч: 'ch',
        ш: 'sh',
        щ: 'shch',
        ъ: '',
        ы: 'y',
        ь: '',
        э: 'e',
        ю: 'yu',
        я: 'ya',
    }

    s = s.toLowerCase() // Convert input string to lowercase

    // Replace Cyrillic characters with corresponding Latin characters
    s = s
        .split('')
        .map((char) => cyrillicLatinMap[char] || char)
        .join('')

    // Normalize the string to NFKD and remove diacritical marks
    s = s.normalize('NFKD').replace(/[\u0300-\u036f]/g, '')

    // Remove all non-alphanumeric characters except spaces and hyphens
    s = s.replace(/[^\w\s-]/g, '').trim()

    // Replace spaces and hyphens with a single hyphen
    return s.replace(/[-\s]+/g, '-')
}

export function getViewportDimensions() {
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    return { width, height }
}

export function copytoClipboard(text) {
    // Use the modern clipboard API if available
    if (navigator.clipboard) {
        navigator.clipboard
            .writeText(text)
            .then(() => {
                console.log('Text copied to clipboard!')
            })
            .catch((err) => {
                console.error('Unable to copy to clipboard:', err)
            })
    }
}

export function formatFileSize(bytes, decimalPlaces = 0) {
    if (bytes === 0) return '0 Bytes'

    const units = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    const factor = Math.floor(Math.log(bytes) / Math.log(1024))
    const size = bytes / Math.pow(1024, factor)
    const formattedSize = size.toFixed(decimalPlaces)

    return `${formattedSize} ${units[factor]}`
}

export function throttle(func, limit = 300) {
    /*
        Universal throttle method that limits how frequently a function can be called
    */
    let inThrottle = false

    return function (...args) {
        if (!inThrottle) {
            func.apply(this, args)
            inThrottle = true

            setTimeout(() => {
                inThrottle = false
            }, limit)
        }
    }
}

export function debounce(func, wait = 300) {
    /* 
        Universal debouncing utility
    */
    let timeout

    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout)
            func(...args)
        }

        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
    }
}

export function uniqueName(candidate, already_have) {
    /*
        ensuring that newly created item name will be unique

        candidate - proposed name of new item from some method
        already_have - array of names of already existing items

        returns new name for new item
        if candidate is already in already_have, returns candidate with [count] appended
    */

    // If candidate doesn't exist in already_have, return it as-is
    if (!already_have.includes(candidate)) {
        return candidate
    }

    // Find all existing copies and get highest number
    let maxCount = 0
    const baseRegex = new RegExp(`^${candidate}\\s*\\[(\\d+)\\]$`)

    for (const name of already_have) {
        const match = name.match(baseRegex)
        if (match) {
            const count = parseInt(match[1])
            maxCount = Math.max(maxCount, count)
        }
    }

    // Return candidate with next number
    return `${candidate} [${maxCount + 1}]`
}
